export default "__VITE_ASSET__DV_h$alb__"